<template>
  <div>
    <div class="roomChange">
      <div class="subTitle">个人信息</div>
      <div class="padding-20 bg-fff">
          <div class="listBox">
            <img class="thumbnail" :src="Url + query.pageDate.photoUrl">
            <div class="mesList">
              <div class="title color-333 font-size-14px margin-top-8">姓名：{{query.pageDate.studentName}}</div>
              <p class="color-666 font-size-26 margin-top-8">学号：{{query.pageDate.studentNo}}</p>
              <p class="color-666 font-size-26 margin-top-8">学院：{{query.pageDate.studentCollegeName}}</p>
              <p class="color-666 font-size-26 margin-top-8">当前年级：{{query.pageDate.studentYear}}级</p>
            </div>
          </div>
        </div>
        <div class="subTitle margin-top-20">换寝信息</div>
        <div class="padding-20 bg-fff">
          <div class="listBox">
            <div class="mesList">
              <p class="color-666 font-size-26 margin-top-8">申请时间：{{query.pageDate.createdDt}}</p>
              <p class="color-666 font-size-26 margin-top-8">原来住址：{{query.pageDate.oldRoomName}}</p>
              <p class="color-666 font-size-26 margin-top-8">换房地址：{{query.pageDate.newRoomName}}</p>
              <p class="color-666 font-size-26 margin-top-8">换寝原因：{{query.pageDate.reason}}</p>
              <p class="color-666 font-size-26 margin-top-8">联系电话：{{query.pageDate.studentPhone}}</p>
              <p class="color-666 font-size-26 margin-top-8">审批材料：</p>
              <img class="thumbnail margin-top-20" :src="Url + query.pageDate.attrUrl" @click="openBigImg(query.pageDate.attrUrl)">
              <p class="color-666 font-size-26 margin-top-20">换房状态：{{query.pageDate.audit2Status}}</p>
            </div>
          </div>
        </div>
    </div>

    <div class="grid bg-appStyle color-fff footer" v-if="query.type == 1 && query.pageDate.audit2Status == '待审核'">
      <div class="gridWarp nopadding noborder">
        <div class="gridCell flex-1"  @click="handleApply('/wx/changeRoom/sq/closeApply', 'get', '1')" style="border-right: 1px solid #fff;">
          关闭申请
        </div>
      </div>
    </div>
    <div class="grid bg-appStyle color-fff footer" v-if="query.type == 2 && query.pageDate.audit2Status == '待审核'">
      <div class="gridWarp nopadding noborder">
        <div class="gridCell flex-basis-50"  @click="handleApply('/wx/changeRoom/audit/hqTeacherAuditSubmit', 'post', '3')" style="border-right: 1px solid #fff;">
          同意
        </div>
        <div class="gridCell flex-basis-50"  @click="handleApply('/wx/changeRoom/audit/hqTeacherAuditSubmit', 'post', '2')" style="border-right: 1px solid #fff;">
          拒绝
        </div>
      </div>
    </div>
    <div class="grid bg-appStyle color-fff footer" v-if="query.type == 4">
      <div class="gridWarp nopadding noborder">
        <div class="gridCell flex-1"  @click="handleApply('/wx/changeRoom/audit/doOutRoom', 'post', '4')" style="border-right: 1px solid #fff;">
          确认搬出
        </div>
      </div>
    </div>
    <div class="grid bg-appStyle color-fff footer" v-if="query.type == 5">
      <div class="gridWarp nopadding noborder">
        <div class="gridCell flex-1"  @click="handleApply('/wx/changeRoom/audit/doInRoom', 'post', '5')" style="border-right: 1px solid #fff;">
          确认搬入
        </div>
      </div>
    </div>

    <div v-if="showImgModal" class="imgModal" @click="closeImg()">
      <img class="img" :src="Url + query.pageDate.attrUrl">
    </div>

  </div>
</template>

<script>

import Vue from 'vue'
import { mapGetters } from "vuex";
import { Toast } from 'mint-ui';
import api from "../fetch/api";

import service from "@/fetch/service";
import * as types from '@/vuex/types';
export default {
  components: {},
  data() {
    return {
      Url: types.URL,
      showImgModal: false
    };
  },
  created() {
    console.log(this.$route.query)
    console.log(this.$route.query.pageDate)
  },
  computed:{
    ...mapGetters([]),
    query: {
      get: function () {
          return this.$route.query;
      }
    }
  },
  mounted() {
    
  },
  methods: {
    openBigImg(img) {
      var imgUrl = this.Url + img;
      console.log(imgUrl);
      this.showImgModal = true; 
    },
    closeImg() {
      this.showImgModal = false; 
    },
    handleApply(url, getFun, type) {
      let that = this
      this.$store.dispatch("setLoadingState", true);
      let params = {}
      if (type == 1) {
        params.id = that.query.pageDate.id;
      }else if (type == 2) {
        params.result = 2; //	1:同意，2:拒绝
        params.applyId = that.query.pageDate.id;
      }else if (type == 3) {
        params.result = 1;
        params.applyId = that.query.pageDate.id;
      }else {
        params.applyId = that.query.pageDate.id;
      }
      console.log(params)
      if (getFun == 'get') {
        api.get(url, params)
        .then(res => {
            this.$store.dispatch("setLoadingState", false);
            console.log(res);
            if (res.success) {
              Toast(res.msg);
              setTimeout(() => {
                this.$router.go(-1);
              }, 500);
                
            }else {
                Toast(res.msg);
            }

        })
        .catch(error => {
            console.log(error);
        });
      }else {
        api.post(url, params)
        .then(res => {
            this.$store.dispatch("setLoadingState", false);
            console.log(res);
            if (res.success) {
                Toast(res.msg);
                setTimeout(() => {
                  this.$router.go(-1);
                }, 500);
            }else {
                Toast(res.msg);
            }

        })
        .catch(error => {
            console.log(error);
        });
      }
      
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/function";
$them-color: #03a9f4;
.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
}
.footerBtn {
  width: 100%;
  height: px2rem(100px);
  background: $them-color;
  // position: fixed;
  // bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
}
.flex-basis-50 {
  flex-basis: 50% !important;
}
.imgModal {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(225, 225, 225, 225);
  top: 0;
  z-index: 1000;
  .img {
    width: 100%;
    height: px2rem(800px);
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    /* Internet Explorer */
    -moz-transform: translateY(-50%);
    /* Firefox */
    -webkit-transform: translateY(-50%);
    /* Safari 和 Chrome */
    -o-transform: translateY(-50%);
    /* Opera */
  }
}
.roomChange {
  
  background: #f5f5f5;
  .font-size-14px{
    font-size: 14px;
  }
  .flex-basis-60 {
    flex-basis: px2rem(110px) !important;
    padding: 0 px2rem(10px);
  }
  padding: px2rem(20px);
  .subTitle {
    font-size: 14px;
    padding: px2rem(20px);
    font-weight: bold;
  }
  .exchageRoom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: px2rem(20px) px2rem(20px);
    background: #fff;
    .pickerBoxs {
      display: flex;
      font-size: 14px;
      margin-top: px2rem(20px);
      align-items: center;
      .dropdownBox {
        margin-left: px2rem(20px);
        .dropdown {
          padding: px2rem(10px);
          border: 1px solid #333;
        }
      }
    }
    .quedingBtn {
      width: px2rem(150px);
      height: px2rem(50px);
      line-height: px2rem(50px);
      background: #03a9f4;
      align-self: center;
      border-radius: px2rem(10px);
      text-align: center;
      color: #fff;
    }
  }
  ////图片上传样式 ------start添加图片
  .upload-imgs{
    margin: 0 px2rem(20px);
    overflow: hidden;
    font-size: 0;
    background: #fff;
    padding: px2rem(20px) px2rem(10px);
  }
  .upload-imgs li{
    position: relative;
    width: px2rem(200px);
    height: px2rem(200px);
    font-size: 14px;
    display: inline-block;
    padding: px2rem(20px);
    margin-right: px2rem(15px);
    border: 1px dashed $them-color;
    text-align: center;
    vertical-align: middle;
  }
  // .upload-imgs li:hover{
  //   border-color: $them-color;
  // }
  .upload-imgs .imgAdd {
    width: px2rem(100px);
    height: px2rem(100px);
  }
  .upload-imgs .add{
    display: block;
    background-color: $them-color;
    width: px2rem(200px);
    height: px2rem(200px);
  }
  .upload-imgs .add .iconfont{
    padding: 10px 0;
    font-size: 40px;
  }
  // .upload-imgs li:hover .add{
  //   background-color: $them-color;
  // }
  .upload-imgs li .upload{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    width: px2rem(200px);
    height: px2rem(300px);
    padding: px2rem(20px);
    margin-top: px2rem(-100px);
  }
  .upload-imgs .img,
  .upload-imgs .img img{
    position: relative;
    width: px2rem(200px);
    height: px2rem(200px);
    line-height: px2rem(200px);
  }
  .upload-imgs .img img{
    vertical-align: middle;
  }
  .upload-imgs .img .close{
    display: none;
  }
  .upload-imgs li .img .close{
    display: block;
    position: absolute;
    right: 0;
    top: 0;
    line-height: 1;
    font-size: px2rem(60px);
    color: #fff;
  }
  //图片上传样式 ------end
  //换寝原因
  .HqTextarea {
    width: px2rem(500px);
    height: px2rem(150px);
    border-radius: px2rem(15px);
    padding: px2rem(20px);
    border: none;
  }
  .telPhone {
    width: px2rem(500px);
    height: px2rem(60px);
    border-radius: px2rem(15px);
    padding: px2rem(20px);
  }
  .margin-bottom {
    margin-bottom: px2rem(100px);
  }
  .listBox {
    .bg-f9b625 {
      background: #f9b625;
    }
    display: flex;
    //缩略图
    .thumbnail {
        width: px2rem(136px);
        height: px2rem(136px);
        margin-right: px2rem(30px);
        border-radius: px2rem(5px);
    }
    //缩略图-长方形
    .thumbnail-max {
        width: px2rem(210px);
        height: px2rem(136px);
        margin-right: px2rem(26px);
        border-radius: px2rem(5px);
    }
    //基本信息栏
    .mesList {
        flex: 1;
        .title {
            display: flex;
            align-items: center;
            flex: 1;
            //列表 标签
            .label {
                flex: none;
                display: inline-block;
                padding: 0 px2rem(15px);
                height: px2rem(32px);
                line-height: px2rem(32px);
                color: #fff;
                border-radius: px2rem(3px);
                margin-right: px2rem(16px);
                margin-left: px2rem(20px);
                font-size: px2rem(22px);
            }
        }
        //标签靠右-标签
        .title-label-right {
            justify-content: space-between;
        }
        p {
            color: #666;
            font-size: px2rem(26px);
            margin-top: px2rem(25px);
        }
    }
  }
}
</style>


// WEBPACK FOOTER //
// RoomChangeDetial.vue?3b53e950